/** Shared role gate: true when the JWT role allows managing firm or company users. */
export function canManageUsers(jwtRole: string | undefined): boolean {
  if (jwtRole === undefined || jwtRole === '') return true;
  return jwtRole === 'Admin' || jwtRole === 'FirmAdmin';
}
